"use strict";

exports.__esModule = true;
exports.DashboardList = DashboardList;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _System = require("../../../System");
var _Theme = require("../../Theme");
var _DashboardThumbnail = require("../DashboardThumbnail");
var _Core = require("../../Core");
var _excluded = ["onItemClick", "items", "selectedIds"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var DashboardListContainer = _styledComponents["default"].div.withConfig({
  displayName: "DashboardListlegacy__DashboardListContainer",
  componentId: "sc-1fhlciu-0"
})(["display:grid;height:100%;padding:1.25rem;grid-gap:1.25rem;grid-template-columns:repeat(auto-fill,minmax(calc(144px + 1rem),1fr));grid-template-rows:repeat(auto-fill,calc(144px + 2rem));"]);
var DashboardListItem = (0, _styledComponents["default"])(_reactRouterDom.Link).withConfig({
  displayName: "DashboardListlegacy__DashboardListItem",
  componentId: "sc-1fhlciu-1"
})(["color:", ";background:", ";box-shadow:0 0 5px ", ";border-radius:", ";transition:box-shadow 0.3s;transition:background 0.5s;padding:0.5rem;display:flex;flex-direction:column;justify-content:center;align-items:center;& svg{color:#000;&:hover{color:#000;}}&:hover{text-decoration:none;color:", ";background:", ";box-shadow:0 0 5px ", ";}"], (0, _Theme.selectable)("ThumbnailListItemColor"), (0, _Theme.selectable)("ThumbnailListItemBackground"), (0, _Theme.selectable)("ThumbnailListItemShadow"), (0, _Theme.selectable)("ThumbnailListItemBorderRadius"), (0, _Theme.val)("SelectedThumbnailListItemColor"), (0, _Theme.val)("SelectedThumbnailListItemBackground"), (0, _Theme.val)("SelectedThumbnailListItemShadow"));
var DashboardListItemLabel = _styledComponents["default"].div.withConfig({
  displayName: "DashboardListlegacy__DashboardListItemLabel",
  componentId: "sc-1fhlciu-2"
})(["display:block;height:32px;margin:0.25rem;font-size:0.875rem;text-align:center;line-height:1rem;color:", ";&:hover{color:", ";}"], (0, _Theme.selectable)("ThumbnailListItemColor"), (0, _Theme.selectable)("ThumbnailListItemColor"));
function renderDashboard(item, selectedIds, onItemClick) {
  return /*#__PURE__*/_react["default"].createElement(_Core.ErrorBoundary, null, /*#__PURE__*/_react["default"].createElement(DashboardListItem, {
    key: item.id,
    "data-testid": "DashboardListItem",
    to: (0, _System.getScreenURL)("Dashboard", item),
    "aria-selected": selectedIds.includes(item.id),
    onClick: typeof onItemClick !== "function" ? undefined : function (e) {
      e.preventDefault();
      onItemClick(item);
    }
  }, /*#__PURE__*/_react["default"].createElement(_DashboardThumbnail.DashboardThumbnail, {
    width: 140,
    height: 105,
    dashboard: item
  }), /*#__PURE__*/_react["default"].createElement(DashboardListItemLabel, {
    "data-testid": "DashboardListItem.label"
  }, item.name)));
}

/**
 * Shows a list of dashboards.
 */
function DashboardList(_ref) {
  var onItemClick = _ref.onItemClick,
    items = _ref.items,
    _ref$selectedIds = _ref.selectedIds,
    selectedIds = _ref$selectedIds === void 0 ? [] : _ref$selectedIds,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(DashboardListContainer, _extends({
    "data-testid": "DashboardList"
  }, extra), items.map(function (item) {
    return renderDashboard(item, selectedIds, onItemClick);
  }));
}